import { Input } from "@mui/material";
import { useState } from "react";

type PgyDeltaInputProps = {
  setDeltaValue: (val: number | undefined) => void;
  currentDeltaValue?: number;
};

function formatIntAsDelta(val: number) {
  return `${val > 0 ? "+" : ""}${val}`;
}

const PgyDeltaInput = ({
  setDeltaValue,
  currentDeltaValue
}: PgyDeltaInputProps) => {
  const [inputVal, setInputVal] = useState<string>(
    currentDeltaValue ? formatIntAsDelta(currentDeltaValue) : "+1"
  );

  return (
    <Input
      style={{ maxWidth: 35 }}
      type="text"
      value={inputVal}
      onChange={(e) => {
        if (!e.target.value.match(/^([-+]?\d*)?$/)) return;

        const value = parseInt(e.target.value);
        let finalInt: number | undefined;

        if (isNaN(value) || value === 0) {
          finalInt = undefined;
        } else if (value < -11) {
          finalInt = -11;
        } else if (value > 11) {
          finalInt = 11;
        } else {
          finalInt = value;
        }

        const finalString = finalInt
          ? formatIntAsDelta(finalInt)
          : e.target.value;

        setDeltaValue(finalInt);
        setInputVal(finalString);
      }}
    />
  );
};

export default PgyDeltaInput;
